import Select from "react-select";
import { Spinner } from "@fluentui/react";
import { FixedSizeList as List } from "react-window";

const CustomMenuList = ({ children }) => {
  const itemCount = Array.isArray(children) ? children.length : 0;
  const height = 35;
  const totalHeight = itemCount > 0 ? Math.min(300, itemCount * height) : height;

  if (itemCount === 0) {
    return null;
  }

  return (
    <List height={totalHeight} itemCount={itemCount} itemSize={height} width="100%">
      {({ index, style }) => (
        <div
          style={{
            ...style,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            padding: "0 8px",
            boxSizing: "border-box"
          }}
          title={children[index]?.props?.children}
        >
          {children[index]}
        </div>
      )}
    </List>
  );
};

const SsoCobrandSelector = ({ options, value, onChange, loading, disabled, label = "Select Cobrand" }) => (
  <div className="mb20" style={{ maxWidth: 700 }}>
    <label className="default-label">{label}</label>
    <Select
      isDisabled={disabled}
      isLoading={loading}
      options={options}
      value={value}
      onChange={onChange}
      placeholder="Select Cobrand"
      components={{ MenuList: CustomMenuList }}
      menuPortalTarget={document.body}
      // Fluent UI Dialog layers render at z-index 1000000
      styles={{ menuPortal: (base) => ({ ...base, zIndex: 1000001 }) }}
    />
    {loading && <Spinner label="Loading cobrand IdP details..." />}
  </div>
);

export default SsoCobrandSelector;
